<template>
  <custom-tab-item :active="active" title="Resumen de Servicios">
    <article>
      <section v-if="detail.length > 0" class="container-fluid mb-4">
        <icon-view
          gradient
          icon="fa fa-file-invoice-dollar"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Servicio(s) bajo contrato"
        />

        <row
          v-for="item in detail"
          :key="`${item.visitSummaryId}-${item.serviceId}`"
          :item="item"
        />
      </section>
    </article>
    <section v-if="detail.length === 0" class="container-fluid mb-4">
      <div class="empty-content text-center">
        <label>
          No cuenta con servicios adicionales para facturar en este periodo.
        </label>
      </div>
    </section>
  </custom-tab-item>
</template>

<script>
import { CustomTabItem } from 'custom-tabs';
import IconView from '../IconView';
import Row from './TabServiceSummaryRow.vue';
export default {
  components: {
    CustomTabItem,
    IconView,
    Row,
  },
  props: {
    detail: {
      type: Array,
      default: () => new Array(),
      require: true,
    },
    active: {
      type: Boolean,
      require: false,
      default: false,
    },
    disable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedList() {
      const list = this?.detail?.services ?? [];
      return list.filter((x) => x.isSelected);
    },
    availableList() {
      const list = this?.detail?.services ?? [];
      return list.filter((x) => !x.isSelected);
    },
  },
  mounted() {
    this.$emit('getServiceSummary');
  },
};
</script>

<style>
.empty-content {
  background: #f7f7f7;
  border-radius: 7px;
  margin: 10px 0 0 0;
  padding: 15px 0 6px 26px;
}
</style>
